import React from 'react';
import {NavLink} from "react-router-dom";

type LinkProps = {
    to: string
    className?: string
    activeClassName?: string
    onClick?: () => void
    end?: boolean
}

const Link: React.FC<React.PropsWithChildren<LinkProps>> = (props) => {
    const {onClick, to, children, className, activeClassName, end} = props;


    const classNames = ({isActive}) => className + (isActive ? ' ' + activeClassName : '');

    return (
        <NavLink onClick={onClick} to={to} className={classNames} end={end}>
            {children}
        </NavLink>
    );
}

export default Link;
